export const USDTTokenAddress = '0xe46Ad90011Ea093C63F72Ae3d0BE24415BCE529F';
export const EscrowAddress = '0xC73FCedF5B0708A573234b3872A972397154BF26';
export const AgreementAddress = '0xc6b1fD85F0BB94B2db94ed97acF90Fed14124f1f'